/**
 * @file 記事取得
 */
'use strict';

import Template from '../../Templates/Template';

/**
 * @classname GetArticle
 * @classdesc 記事取得
 */
export default class GetArticles {
	/**
	 * @constructor
	 * @param {object} controller - controller オブジェクト
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e, controller) {
		console.log('GetArticles.constructor');
		this._$e = $e;
		this._articleType = parseInt($e.attr('data-type'));
		this._page = parseInt($e.attr('data-article-page'));
		this._controller = controller;
		$e.on('click', () => this.onClick());
        controller.on('completeGetArticles', () => this.onCompleteGetArticles());
    };


	/**
	 * clickのコールバック
	 *
	 * @memberof GetArticles
	 * @return {undefined}
	 */
    onClick() {
		console.log('GetArticles.centerChanged');
		this._controller.getArticles(this._page, this._articleType, 18);
	};


    /**
     * データ取得
     *
     * @memberof GetArticles
     * @return {undefined}
     */
    onCompleteGetArticles() {
        console.log('GetArticles.onCompleteGetArticles');
        this._data = this._controller._data;
        console.log(this._data);
        const list = this._data.list;
        const total = this._data.total;
        for(let i = 0; i < list.length; i++){
            const item = list[i];
            let article = '';
            if(this._articleType === 1){
                article = Template.createMagazine(item);
            }else if(this._articleType === 2){
                article = Template.createBlog(item);
            }
            $('.list--report').append(article);
        }
        const totalPage = Math.ceil(total / 18);
        if(this._page === totalPage) this._$e.remove();
        this._page ++;
        this._$e.attr('data-article-page', this._page);
    };
}
